import { render } from "./auth-login.vue?vue&type=template&id=51610aac&scoped=true"
import script from "./auth-login.vue?vue&type=script&lang=js"
export * from "./auth-login.vue?vue&type=script&lang=js"

import "./auth-login.vue?vue&type=style&index=0&id=51610aac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51610aac"]])

export default __exports__